export default {
    "视频": "视频",
    "文章": "文章",
    "频道": "频道",
    "活动": "活动",
    "用户": "用户",
    "搜索": "搜索",
    "共找到": "共找到",
    "个结果": "个结果",
    "对结果不满意？请告诉我们": "对结果不满意？请告诉我们",
    "综合排序": "综合排序",
    "最新创作": "最新创作",
    "最多浏览": "最多浏览",
    "最多点赞": "最多点赞",
    "成员": "成员",
    "没有匹配的视频": "没有匹配的视频",
    "没有匹配的文章": "没有匹配的文章",
    "没有匹配的频道": "没有匹配的频道",
    "没有匹配的活动": "没有匹配的活动",
    "没有匹配的用户": "没有匹配的用户",
    "热门周榜": "热门周榜",


}


// WEBPACK FOOTER //
// ./src/languages/cn/search.js